<template>
    <div class="not-allowed__container">
        <div class="not-allowed__message"><i class="material-icons">error_outline</i>No tienes permiso para acceder a este contenido</div>
        <button class="not-allowed__btn-home" @click.stop="router.push('/')">Ir al inicio<i class="material-icons">arrow_forward</i></button>
    </div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
    setup(){
        const router = useRouter();

        return {
            router,
        }
    }

}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.not-allowed{
    &__container{
        width: 100%;
        height: 100vh;
        @include flex-column;
        gap: 24px;
        padding: 84px 20px; 
    }
    &__message{
        @include icon-and-text-container;
        font-size: 19px;
    }
    &__btn-home{
        padding: 10px 26px;
        @include icon-and-text-container;
        background-color: $green;
        border-radius: 44px;
        color: #fff;
        box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    }
}
</style>

